<div class="acc" dir="rtl">
  @if (state === 'loading') {
    <div class="acc-state" role="status" aria-live="polite">
      <span class="acc-spinner" aria-hidden="true"></span>
      <span>טוען את פרטי הקשר...</span>
    </div>
  }

  @if (state === 'error') {
    <div class="acc-state acc-state--error" role="alert">
      <span>לא הצלחנו לטעון את פרטי הקשר. נסה שוב.</span>
      <button type="button" class="acc-retry" (click)="load()">נסה שוב</button>
    </div>
  }

  @if (state === 'ready') {
    <div class="acc-card">
      @if (isEmpty) {
        <p class="acc-empty">פרטי הקשר אינם זמינים כרגע. ניתן להשאיר לנו הודעה.</p>
      }

      @if (rows.length) {
        <ul class="acc-rows">
          @for (r of rows; track r.key) {
            <li>
              <a class="acc-row" [href]="r.href" [attr.target]="r.external ? '_blank' : null" rel="noopener">
                <span class="acc-row__icon acc-row__icon--{{ r.key }}"><i class="fa {{ r.icon }}" aria-hidden="true"></i></span>
                <span class="acc-row__text">
                  <span class="acc-row__label">{{ r.label }}</span>
                  <span class="acc-row__value" [attr.dir]="r.ltr ? 'ltr' : null">{{ r.value }}</span>
                </span>
                <i class="fa fa-angle-left acc-row__arrow" aria-hidden="true"></i>
              </a>
            </li>
          }
        </ul>
      }

      @if (hours.length) {
        <div class="acc-section">
          <div class="acc-section__title">שעות פעילות</div>
          <ul class="acc-hours">
            @for (h of hours; track $index) {
              <li [class.acc-hours--closed]="h.closed">
                <span>{{ h.day }}</span>
                <span dir="ltr">{{ h.hours }}</span>
              </li>
            }
          </ul>
        </div>
      }

      @if (social.length) {
        <div class="acc-section">
          <div class="acc-section__title">רשתות חברתיות</div>
          <div class="acc-social">
            @for (s of social; track s.key) {
              <a class="acc-social__item" [href]="s.href" target="_blank" rel="noopener" [title]="s.label">
                <i class="fa {{ s.icon }}" aria-hidden="true"></i>
                <span>{{ s.label }}</span>
              </a>
            }
          </div>
        </div>
      }

      <button type="button" class="acc-form-btn" (click)="openContactForm.emit()">שלח לנו הודעה בטופס צור קשר</button>
    </div>
  }
</div>
